import Step from '@/services/step'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const find = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Step.fetch().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = (context, payload) => {
  return new Promise((resolve, reject) => {
    Step.save(payload.assignor).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data.errors)
      })
      reject(error)
    })
  })
}

const sendDocumentation = (context) => {
  return new Promise((resolve, reject) => {
    Step.sendDoc().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  find,
  save,
  sendDocumentation
}



// WEBPACK FOOTER //
// ./src/features/steps/store/actions.js